module.exports = __webpack_public_path__ + "static/media/jovana-jankovic.225db80f.jpg";